import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { browserHistory } from 'react-router';
import { isConfirmTransformSuperSpeedItemsPopupShown, popupParamsSelector } from 'swag-client-common/redux/popup-manager/popup-manager.selector';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { transformSuperSpeedItemsToStandard } from 'swag-client-common/redux/cart/cart.actions';
import { hidePopup } from 'swag-client-common/redux/popup-manager/popup-manager.actions';
import { resetBoxBuilderState } from '../../../redux/box-builder/box-builder.actions';
import { ConfirmTransformSuperSpeedItemsPopupComponent } from './confirm-transform-super-speed-items-popup';
const redirectToCartIfNeeded = () => {
  const location = browserHistory.getCurrentLocation();
  if (location.pathname !== APP_ROUTES.CART) {
    browserHistory.push(APP_ROUTES.CART);
  }
};
const mapStateToProps = createStructuredSelector({
  open: isConfirmTransformSuperSpeedItemsPopupShown,
  params: popupParamsSelector
});
const mapDispatchToProps = dispatch => ({
  onConfirm: () => {
    dispatch(transformSuperSpeedItemsToStandard());
    dispatch(hidePopup());
    dispatch(resetBoxBuilderState());
    redirectToCartIfNeeded();
  },
  onClose: () => {
    dispatch(resetBoxBuilderState());
    dispatch(hidePopup());
    redirectToCartIfNeeded();
  }
});
export const ConfirmTransformSuperSpeedItemsPopup = connect(mapStateToProps, mapDispatchToProps)(ConfirmTransformSuperSpeedItemsPopupComponent);